import { useExperimentFlag } from '../../../../../utils/useExperimentFlag';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { StatisticItem } from '../StatisticItem/StatisticItem';
import { StatisticSkeleton } from '../StatisticSkeleton/StatisticSkeleton';
import { StatisticContentProps } from './types';

export const StatisticContent: React.FC<StatisticContentProps> = ({
    statisticLoading,
    statistic,
    isService,
}) => {
    const t = useTranslation();

    if (statisticLoading) {
        return <StatisticSkeleton />;
    }

    if (!statistic) {
        return (
            <Flex width="100%" alignItems="center">
                <Typography variant="body2" p={2}>
                    {t('Не удалось загрузить статистику')}
                </Typography>
            </Flex>
        );
    }

    const { shows, showsInGrid, subscribers, interactions, purchases, gmv } = statistic;

    const enableNewStat = useExperimentFlag('enable_gmv_visits_purchases_carts') && !isService;

    return (
        <Flex
            width="100%"
            direction="row"
            alignItems="stretch"
            justifyContent="stretch"
            flexWrap="wrap"
        >
            <StatisticItem
                title={t('Показы в ленте')}
                displayValue={showsInGrid.total.display}
                diffValue={showsInGrid.total.diffValue}
                diffDisplay={showsInGrid.total.diffDisplay}
                mr={1}
            />
            {enableNewStat ? null : (
                <StatisticItem
                    title={t('Показы с действием')}
                    displayValue={shows.total.display}
                    diffValue={shows.total.diffValue}
                    diffDisplay={shows.total.diffDisplay}
                    mr={{ xs: 0, sm: 1 }}
                />
            )}
            {enableNewStat ? null : (
                <StatisticItem
                    title={t('Подписчики')}
                    displayValue={subscribers.total.display}
                    diffValue={subscribers.total.diffValue}
                    diffDisplay={subscribers.total.diffDisplay}
                    mr={1}
                />
            )}
            <StatisticItem
                title={t('Клики по ссылке')}
                displayValue={interactions.clicks.display}
                diffValue={interactions.clicks.diffValue}
                diffDisplay={interactions.clicks.diffDisplay}
            />
            {enableNewStat && purchases ? (
                <StatisticItem
                    title={t('Покупки')}
                    displayValue={purchases.total.display}
                    diffValue={purchases.total.diffValue}
                    diffDisplay={purchases.total.diffDisplay}
                    ml={{ xs: 0, sm: 1 }}
                />
            ) : null}
            {enableNewStat && gmv ? (
                <StatisticItem
                    title={t('GMV')}
                    displayValue={gmv.total.display}
                    diffValue={gmv.total.diffValue}
                    diffDisplay={gmv.total.diffDisplay}
                    ml={1}
                />
            ) : null}
        </Flex>
    );
};
